import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createTask, deleteTask, getDeletedTask, getTask, getTasksStatusesCount, queryTasks, searchTasks, updateTask } from '@wix/ambassador-ai-scheduling-assistant-v1-task/http';
import { getEnrichedTask, queryEnrichedTasks } from '@wix/ambassador-asa-enriched-task-v1-enriched-task/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { TasksClientBase } from './TasksClientBase';
export class TasksClient extends HttpBaseClient(TasksClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getTaskImpl", getTask);
    _defineProperty(this, "queryTasksImpl", queryTasks);
    _defineProperty(this, "searchTasksImpl", searchTasks);
    _defineProperty(this, "updateTaskImpl", updateTask);
    _defineProperty(this, "createTaskImpl", createTask);
    _defineProperty(this, "deleteTaskImpl", deleteTask);
    _defineProperty(this, "countTaskByStatusImpl", getTasksStatusesCount);
    _defineProperty(this, "getDeletedTaskImpl", getDeletedTask);
    _defineProperty(this, "getEnrichedTaskImpl", getEnrichedTask);
    _defineProperty(this, "queryEnrichedTasksImpl", queryEnrichedTasks);
  }
}
//# sourceMappingURL=TasksClientHttp.js.map